/** The deck (docs/API.md "Deck"): the signed-in user's workspace layout and watchlist. */
import { AddDeckWatchBody, DeckState, DeckWatchlist, DeckWatchParams, PutDeckLayoutBody } from '../deck.js'
import { defineRoute, type RouteDef } from './define.js'

export const deckRoutes = {
  getMyDeck: defineRoute({
    method: 'GET',
    path: '/me/deck',
    auth: 'session',
    summary: 'The caller’s saved deck layout (null until saved) and watchlist',
    response: DeckState,
  }),
  putMyDeckLayout: defineRoute({
    method: 'PUT',
    path: '/me/deck/layout',
    auth: 'session',
    summary: 'Replace the caller’s deck layout (idempotent: the same body leaves the same state)',
    body: PutDeckLayoutBody,
    response: DeckState,
  }),
  addMyDeckWatch: defineRoute({
    method: 'POST',
    path: '/me/deck/watchlist',
    auth: 'session',
    summary: 'Watch agents or agent tokens (idempotent per entry; unknown entries are skipped)',
    body: AddDeckWatchBody,
    response: DeckWatchlist,
  }),
  removeMyDeckWatch: defineRoute({
    method: 'DELETE',
    path: '/me/deck/watchlist/:kind/:ref',
    auth: 'session',
    summary: 'Stop watching an agent or agent token (idempotent)',
    params: DeckWatchParams,
    response: DeckWatchlist,
  }),
} as const satisfies Record<string, RouteDef>
